/** @jsx jsx */
/** @jsxFrag null */
import {jsx} from 'panel';
import {selx} from 'clsx';

import {ButtonSize, ButtonTheme} from 'common/components/button/constants';
import {InputEl} from 'common/components/input';
import {InputSize} from 'common/components/input/types';

import {CopyToClipboardButtonEl} from './copy-to-clipboard-button';
import type {CopyToClipboard} from './index';
import styles from './index.module.styl';

export function template(this: CopyToClipboard) {
  return (
    <div sel={selx(styles.mpCopyToClipboard)}>
      <InputEl
        sel={selx(styles.copyInput, {[styles.fullWidth]: this.attr(`full-width`)})}
        attrs={{
          readonly: true,
          type: `text`,
          label: this.attr(`label`),
          size: this.attr(`size`) || InputSize.Large,
        }}
        props={{
          value: this.attr(`value`),
        }}
        hook={{
          insert: ({elm}) => this.helpers.handleInsert(elm as HTMLInputElement),
        }}
      />
      <CopyToClipboardButtonEl
        sel={selx(styles.copyButton)}
        attrs={{
          options: [{value: this.attr(`value`)}],
          size: this.attr(`size`) || ButtonSize.Large,
          theme: ButtonTheme.Tertiary,
        }}
      >
        {!this.attr(`icon-only`) && this.t(`components.copy-to-clipboard.copy`)}
      </CopyToClipboardButtonEl>
    </div>
  );
}
